// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"mA","tile":"mB","imageWrapper":"mC","img":"mD","header":"mE","caption":"mF"};